import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function CostField({ biz, value, onChange, testid }) {
  return (
    <div className="space-y-1.5">
      <Label>Cost price ({biz.currency}, optional)</Label>
      <Input inputMode="decimal" className="money h-11" placeholder="Not set" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid} />
      <p className="text-[11px] text-slate-500">Used for profit when stock has no received-goods cost. Only you and people allowed to view profit see this.</p>
    </div>
  );
}
